type TFoundationDateComparison = {
  exactMatch: boolean;
  monthDelta: number;
};

type TCompareInput = {
  crefoFoundationDate?: string;
  startDateMonth?: string;
  startDateYear?: string;
};

// Crefo dates arrive as ISO YYYY-MM-01; the user provides month + 4-digit year.
export const compareFoundationDate = ({
  crefoFoundationDate,
  startDateMonth,
  startDateYear,
}: TCompareInput): TFoundationDateComparison | null => {
  if (!crefoFoundationDate) return null;

  const crefoMatch = /^(\d{4})-(\d{2})-\d{2}$/.exec(crefoFoundationDate);
  if (!crefoMatch) return null;
  const crefoYear = Number(crefoMatch[1]);
  const crefoMonth = Number(crefoMatch[2]);

  const enteredMonth = Number(startDateMonth);
  const enteredYear = Number(startDateYear);
  const yearIsFourDigits = String(startDateYear ?? '').length === 4;
  if (
    !Number.isInteger(enteredMonth) ||
    !Number.isInteger(enteredYear) ||
    enteredMonth < 1 ||
    enteredMonth > 12 ||
    !yearIsFourDigits
  ) {
    return null;
  }

  const monthDelta =
    enteredYear * 12 + enteredMonth - (crefoYear * 12 + crefoMonth);

  return { exactMatch: monthDelta === 0, monthDelta };
};
